"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Types = _interopRequireDefault(require("../../types/Types"));

var _keyOrIndexToKey = _interopRequireDefault(require("../../parcelData/keyOrIndexToKey"));

var _get = _interopRequireDefault(require("../../parcelData/get"));

var _has = _interopRequireDefault(require("../../parcelData/has"));

var _prepareChildKeys2 = _interopRequireDefault(require("../../parcelData/prepareChildKeys"));

var _clone = _interopRequireDefault(require("unmutable/lib/clone"));

var _first = _interopRequireDefault(require("unmutable/lib/first"));

var _last = _interopRequireDefault(require("unmutable/lib/last"));

var _map = _interopRequireDefault(require("unmutable/lib/map"));

var _size2 = _interopRequireDefault(require("unmutable/lib/size"));

var _toArray2 = _interopRequireDefault(require("unmutable/lib/toArray"));

var _toObject2 = _interopRequireDefault(require("unmutable/lib/toObject"));

var _pipeWith = _interopRequireDefault(require("unmutable/lib/util/pipeWith"));

var _default = function _default(_this) {
  return {
    // prepare child keys only once per parcel instance
    // by preparing them and mutating this.parcelData
    _prepareChildKeys: function _prepareChildKeys() {
      if (!_this._parcelData.child) {
        _this._parcelData = (0, _prepareChildKeys2.default)()(_this._parcelData);
      }
    },
    has: function has(key) {
      (0, _Types.default)("has()", "key", "keyIndex")(key);

      _this._methods._prepareChildKeys();

      return (0, _has.default)(key)(_this._parcelData);
    },
    get: function get(key, notFoundValue) {
      (0, _Types.default)("get()", "key", "keyIndex")(key);
      var stringKey = (0, _keyOrIndexToKey.default)(key)(_this._parcelData);
      var cachedChildParcel = _this._childParcelCache[stringKey];

      if (cachedChildParcel) {
        return cachedChildParcel;
      }

      _this._methods._prepareChildKeys();

      var childParcelData = (0, _get.default)(key, notFoundValue)(_this._parcelData); // this shouldn't happen in reality, but I cant prove that to flow right now
      // and it rightly should be an error

      if (childParcelData.key === undefined) {
        throw new Error();
      }

      var childKey = childParcelData.key;

      var childOnDispatch = function childOnDispatch(changeRequest) {
        return changeRequest._addStep({
          type: 'get',
          key: childKey
        });
      };

      var child = _this._parcelData.child;
      var childIsNotEmpty = (0, _size2.default)()(child) > 0;
      var isIndexed = _this._isIndexed;
      var isChildFirst = childIsNotEmpty && (0, _first.default)()(child).key === childKey;
      var isChildLast = childIsNotEmpty && (0, _last.default)()(child).key === childKey;

      var childParcel = _this._create({
        parcelData: childParcelData,
        updateChangeRequestOnDispatch: childOnDispatch,
        id: _this._id.push(childKey, isIndexed),
        parent: {
          isIndexed: isIndexed,
          isChildFirst: isChildFirst,
          isChildLast: isChildLast
        }
      });

      _this._childParcelCache[stringKey] = childParcel;
      return childParcel;
    },
    getIn: function getIn(keyPath, notFoundValue) {
      (0, _Types.default)("getIn()", "keyPath", "keyIndexPath")(keyPath);
      var parcel = _this;

      for (var i = 0; i < keyPath.length; i++) {
        parcel = parcel.get(keyPath[i], i < keyPath.length - 1 ? {} : notFoundValue);
      }

      return parcel;
    },
    children: function children(mapper) {
      (0, _Types.default)("children()", "mapper", "function")(mapper);
      return (0, _pipeWith.default)(_this._parcelData.value, (0, _clone.default)(), (0, _map.default)(function (value, key) {
        return mapper(_this.get(key), key, _this);
      }));
    },
    toObject: function toObject(mapper) {
      (0, _Types.default)("toObject()", "mapper", "function")(mapper);
      return (0, _toObject2.default)()(_this.children(mapper));
    },
    toArray: function toArray(mapper) {
      (0, _Types.default)("toArray()", "mapper", "function")(mapper);
      return (0, _toArray2.default)()(_this.children(mapper));
    },
    size: function size() {
      return (0, _size2.default)()(_this.value);
    }
  };
};

exports.default = _default;